const prestigeServices = [
  { id: 52, name: 'Photography Image Selector' },
  { id: 59, name: 'Prestige Photography with Companion' },
]

export default prestigeServices
